import { useRef, type FocusEvent, type MouseEvent } from 'react';

/**
 * Select-all on focus so typing replaces the value, but a second click
 * can place the caret for partial edits.
 */
export function useSelectAllOnFocus() {
  const justFocusedRef = useRef(false);

  return {
    onFocus: (e: FocusEvent<HTMLInputElement>) => {
      justFocusedRef.current = true;
      // Capture the element — React clears currentTarget after the handler.
      const input = e.currentTarget;
      requestAnimationFrame(() => input.select());
    },
    onMouseUp: (e: MouseEvent<HTMLInputElement>) => {
      if (!justFocusedRef.current) return;
      // Stop the focusing click from collapsing the selection, then select.
      e.preventDefault();
      e.currentTarget.select();
      justFocusedRef.current = false;
    },
  };
}
